module.exports = __webpack_public_path__ + "static/media/0145_Medium.16007edb.jpg";